/**
 * Module: Grid
 * Child blocks
 * - Heading with Paragraph block
 * - Book list block
 * - Button block
 */

/**
 * External dependencies
 */

/**
 * DWT dependencies
 */

import { getInnerBlocks, passAttrsToInnerBlocks } from '../utils/block-utils';

import ListInspectorControls from '../block-components/ListInspectorControls';

/**
 * WP dependencies
 */

import {
  InnerBlocks,
  InspectorControls,
  useBlockProps,
  useInnerBlocksProps
} from '@wordpress/block-editor';

import {
  PanelBody,
  SelectControl,
  ToggleControl
} from '@wordpress/components';

import { __ } from '@wordpress/i18n';

const Edit = ({ attributes, setAttributes, clientId }) => {
  const {
    isGrid,
    featureBy,
    filterBy,
    divisionCode,
    imprintCode,
    seriesCode,
    bisacCode,
    brandCode,
    showMetadata,
    showCovers,
    filterByOptions,
    layout,
    horizontalRule
  } = attributes;

  /**
     * General settings/styles
     */

  const obj = {
    featureBy,
    filterBy,
    divisionCode,
    imprintCode,
    seriesCode,
    bisacCode,
    brandCode,
    showMetadata,
    showCovers,
    filterByOptions
  };

  passAttrsToInnerBlocks( clientId, obj );

  /**
     * Block settings/styles
     */

  const blockProps = useBlockProps({
    className: `block__grid`
  });

  /**
     * innerBlocks settings/styles
     */

  const innerBlocks = getInnerBlocks( clientId );

  const template = [
    [
      'core/group',
      {},
      [
        [ 'dwt/heading-with-paragraph', {} ],
        [ 'dwt/button', {} ]
      ]
    ],
    [ 'dwt/product-list', {} ]
  ];

  // eslint-disable-next-line no-unused-vars
  const { children, ...innerBlocksProps } = useInnerBlocksProps(
    { className: `inner-blocks-wrapper relative ${layout}` },
    {
      allowedBlocks: [],
      template
    }
  );

  let listInnerBlocks;

  Object.entries( innerBlocks ).forEach( ( [ key, value ] ) => {
    if ( value.name === 'dwt/product-list' ) {
      listInnerBlocks = value.innerBlocks;
    }
  });

  /**
     * handle layout
     */

  const handleLayout = ( newLayout ) => setAttributes({ layout: newLayout });

  return (
    <>
      <InspectorControls>
        <PanelBody title={__( 'Main settings', 'dwt-custom-theme' )}>
          <ListInspectorControls
            setAttributes={setAttributes}
            isGrid={isGrid}
            featureBy={featureBy}
            filterBy={filterBy}
            divisionCode={divisionCode}
            imprintCode={imprintCode}
            seriesCode={seriesCode}
            bisacCode={ bisacCode }
            brandCode={ brandCode }
            showMetadata={showMetadata}
            showCovers={showCovers}
            filterByOptions={filterByOptions}
            innerBlocks={listInnerBlocks}
          />
        </PanelBody>

        <PanelBody title={__( 'Styling settings', 'dwt-custom-theme' )}>
          <SelectControl
            label={__( 'Layout', 'dwt-custom-theme' )}
            value={layout}
            options={[
              { label: 'Left Aligned', value: 'is-left-aligned' },
              {
                label: 'Center Aligned',
                value: 'is-center-aligned'
              }
            ]}
            onChange={handleLayout}
            __nextHasNoMarginBottom
          />
          <ToggleControl
            className="editor-toggle-button"
            label={__( 'Divider', 'dwt-custom-theme' )}
            help={__(
              'Displays a thin line at the bottom of the module'
            )}
            checked={horizontalRule}
            onChange={() => {
              setAttributes({ horizontalRule: !horizontalRule });
            }}
          />
        </PanelBody>
      </InspectorControls>

      <div {...blockProps}>
        <div className="grid--inner">
          <div {...innerBlocksProps}>
            <InnerBlocks template={template} templateLock="all" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit;
